// src/components/RouteGuard.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";

import { AuthCtx } from "../context/AuthCtx";

export default function RouteGuard({ moduleKey, children }) {
  const { jwt, role, acl, authReady } = useContext(AuthCtx);

  // While we are still resolving /whoami, avoid redirect flicker
  if (!authReady) {
    return (
      <div className="flex h-screen items-center justify-center text-gray-500">
        Checking permissions...
      </div>
    );
  }

  // Only redirect once bootstrap/refresh has finished.
  if (!jwt) {
    return <Navigate to="/login" replace />;
  }

  // Once auth is ready, enforce module-based access
  if (role === "super" || acl.modules.includes(moduleKey)) {
    return children;
  }

  // Known but unauthorised user -> scoped 403 inside dashboard
  return <Navigate to="/dashboard/not-authorised" replace />;
}
